module.exports = __webpack_public_path__ + "img/04_content_01.51f8ffb9.png";